import type { ComponentType } from 'react'
import { AimOutlined, ApartmentOutlined, AppstoreOutlined, BarChartOutlined, BookOutlined,
  BranchesOutlined, CodeOutlined, FileSyncOutlined, FileTextOutlined, FilterOutlined, FolderOutlined,
  FormOutlined, LinkOutlined, NodeIndexOutlined, RobotOutlined, SettingOutlined, ShopOutlined,
  TableOutlined, TeamOutlined, ToolOutlined, UserOutlined } from '@ant-design/icons'

/** Visual asset keys are shared; business identities never select an icon. */
export const ICONS = new Map<string, { label: string; component: ComponentType }>([
  ['aim', { label: '目标', component: AimOutlined }],
  ['bar-chart', { label: '图表', component: BarChartOutlined }],
  ['node-index', { label: '节点', component: NodeIndexOutlined }],
  ['branches', { label: '分支', component: BranchesOutlined }],
  ['workflow', { label: '流程', component: ApartmentOutlined }],
  ['file', { label: '文档', component: FileTextOutlined }],
  ['file-text', { label: '文本', component: FileTextOutlined }],
  ['file-sync', { label: '文档同步', component: FileSyncOutlined }],
  ['folder', { label: '目录', component: FolderOutlined }],
  ['form', { label: '表单', component: FormOutlined }],
  ['filter', { label: '筛选', component: FilterOutlined }],
  ['link', { label: '关联', component: LinkOutlined }],
  ['table', { label: '表格', component: TableOutlined }],
  ['book', { label: '知识', component: BookOutlined }],
  ['code', { label: '代码', component: CodeOutlined }],
  ['robot', { label: '智能体', component: RobotOutlined }],
  ['user', { label: '个人', component: UserOutlined }],
  ['team', { label: '组织', component: TeamOutlined }],
  ['shop', { label: '商家', component: ShopOutlined }],
  ['tool', { label: '工具', component: ToolOutlined }],
  ['setting', { label: '设置', component: SettingOutlined }],
  ['appstore', { label: '应用', component: AppstoreOutlined }],
])

export const iconForKey = (key?: string | null, fallback = 'appstore') =>
  (ICONS.get(key ?? '') ?? ICONS.get(fallback) ?? ICONS.get('appstore'))!.component
